import { TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { MatDialog } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EsimService } from '../esim.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { AuthService } from 'src/app/services/auth.service';
import { CompleteProfileModalComponent } from '../../../components/modals/complete-profile-modal.component';
import { Auth } from 'aws-amplify';
import { UtilsService } from '../../../utils/utils.service';
import { PromoService } from '../../../components/promo/promo.service';
import { PromoComponent } from '../../../components/promo/promo.component';
import { GlobalDataService } from '../../../services/global-data.service';

@Component({
  selector: 'app-esim-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(
          0,
          0,
          0,
          0.5
        ); /* semi-transparent black background */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999; /* Ensure it's on top of other content */
      }
    `,
  ],
})

export class DetailsComponent implements OnInit {
  acceptTermsCheckbox = false;
  acceptDevicesCheckbox = false;
  showSpinner = false;
  usageData: any = null;
  usageDataShow:boolean = false;
  details: any;
  iccid: string = '';
  country: string = '';
  operator: string = '';
  installationGuide: any = null;
  selectedPlatform: 'android' | 'ios' | null = null;
  isLoading: boolean = false;
  isLoadingDetails: boolean = true;
  esimDetails: any = null;
  price: number | null = null;
  finalPrice: number = 0;
  package_id:string = ""

  // For back navigation
  returnCountry: string | null = null;
  returnType: string | null = null;
  returnView: string | null = null;

  promoCode: string | null = '';
  isPromoAvailable = false;
  priceBeforePromo: number | null = null;

  quantity: number = 1;
  limit: number = 10;

  planType: string = '';
  countryimg: string = '';
  operatorDetails: any;

  dialog = inject(MatDialog);
  sendToProfile = true;

  private user = inject(AuthenticatorService).user;
  auth = inject(AuthService);

  @ViewChild(PromoComponent) promoValue!: PromoComponent;
  promo: any = null



  constructor(
    private esimService: EsimService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    @Inject(TUI_IS_MOBILE) readonly isMobile: boolean,
    private router: Router,
    private utils: UtilsService,
    private promoService: PromoService,
    private globalDataService: GlobalDataService
  ) { }

  ngAfterViewInit() {
    this.promoValue.promo.subscribe((valor: any) => {
      this.promo = valor;
      this.promoCode = valor?.promos[0]?.id;
      this.updatePrice();
    });
  }

  private applyEsimData(esimDetails: any) {
    this.esimDetails = esimDetails;
    if (!esimDetails) return;

    this.iccid = esimDetails.iccid ?? '';
    this.country = esimDetails.country ?? '';
    this.countryimg = esimDetails.operador
      ? esimDetails.countryimg
      : esimDetails.pkg_details?.country_url;
    this.operator = esimDetails.operador?.[0]?.operador ?? esimDetails.operator;
    this.planType = esimDetails.operador?.[0]?.plan_type ?? esimDetails.pkg_details?.operator_info?.plan_type ?? '';
    this.usageData = esimDetails.usage_data ?? null;

    try {
      this.usageDataShow = (this.usageData?.total || 0) !== 0
                        || (this.usageData?.total_voice || 0) !== 0
                        || (this.usageData?.total_text || 0) !== 0;
    } catch {
      this.usageDataShow = false;
    }

    this.price = esimDetails.operador ? (esimDetails.price ?? null) : null;
    this.finalPrice = this.price ?? 0;
    this.operatorDetails = esimDetails.operador?.[0] ?? esimDetails.pkg_details;

    if (this.iccid !== '') {
      this.fetchInstallationGuide(this.iccid);
      this.details = <EsimDetails>{
        country: esimDetails.country,
        data: esimDetails.pkg_details?.data,
        type: esimDetails.pkg_details?.type,
        title: esimDetails.pkg_details?.title,
        is_unlimited: esimDetails.pkg_details?.is_unlimited,
        day: esimDetails.pkg_details?.day,
        plan_type: esimDetails.pkg_details?.operator_info?.plan_type,
        prepaid: esimDetails.pkg_details?.operator_info?.is_prepaid,
        esimtype: esimDetails.pkg_details?.operator_info?.esim_type,
        apn_type: esimDetails.pkg_details?.operator_info?.apn_type,
        info: esimDetails.pkg_details?.info,
        activation_policy: esimDetails.pkg_details?.operator_info?.activation_policy,
        rechargeability: esimDetails.pkg_details?.operator_info?.rechargeability,
        other_info: esimDetails.pkg_details?.operator_info?.other_info
      };
    } else {
      this.details = <EsimDetails>{
        country: esimDetails.country,
        data: esimDetails.data,
        type: esimDetails.type,
        title: esimDetails.title,
        is_unlimited: esimDetails.is_unlimited,
        day: esimDetails.day,
        plan_type: esimDetails.operador?.[0]?.plan_type,
        prepaid: esimDetails.operador?.[0]?.prepaid,
        esimtype: esimDetails.operador?.[0]?.esimtype,
        apn_type: esimDetails.operador?.[0]?.apn_type,
        info: esimDetails.operador?.[0]?.info,
        activation_policy: esimDetails.operador?.[0]?.activation_policy,
        rechargeability: esimDetails.operador?.[0]?.rechargeability,
        other_info: esimDetails.operador?.[0]?.other_info
      };
    }
  }

  private async loadAuthAndPromos() {
    try {
      await this.auth.refresh();
      this.user = await Auth.currentAuthenticatedUser();
      const attributes = await Auth.userAttributes(this.user);

      const userSub = attributes.find(a => a.Name === 'sub')?.Value;
      const address = attributes.find(a => a.Name === 'custom:address')?.Value;
      const country = attributes.find(a => a.Name === 'custom:country')?.Value;
      const city = attributes.find(a => a.Name === 'custom:ciudad')?.Value;
      const zipcode = attributes.find(a => a.Name === 'custom:postcode')?.Value;
      const passport = attributes.find(a => a.Name === 'custom:passport')?.Value;

      this.sendToProfile = !(address && address !== '' && city && city !== '' && zipcode && zipcode !== '' && passport && passport !== '' && country && country !== '' && userSub !== '');

      if (!this.sendToProfile) {
        sessionStorage.removeItem('onsignup_esim_data');
      }

      this.isPromoAvailable = await this.promoService.isPromosActive("esim");
    } catch (error) {
      console.warn('Background auth/promo load failed:', error);
    }
  }

  async getPackage(id: string) {
    const apiPackages = await this.esimService.getfilteredPackagesbyID(id);

    if (!apiPackages) {
      console.error('Response is undefined or empty');
      return;
    }

    const apiResponse = typeof apiPackages === 'string' ? JSON.parse(apiPackages) : apiPackages;
    const packagesMap: { [key: string]: { country: string, image: string, packages: any[] } } = {};
    const tmpPackage: any[] = [];
    // Procesar cada paquete
    apiResponse.forEach((pkg: any) => {
      if (pkg.pkg_country_code) {
        // Verificar si el país ya está en el mapa
        if (!packagesMap[pkg.pkg_country_code]) {
          // Crear una nueva entrada en el mapa para este país
          packagesMap[pkg.pkg_country_code] = {
            country: pkg.pkg_country,
            image: pkg.pkg_country_url || 'https://cdn-dev.zendy.tel/images/Promo-Zendy-3-24@3x.png', // Proporciona una ruta por defecto si es necesario
            packages: []
          };
        }

        // Aquí agregamos la lógica del `type` para cada paquete
        const type = pkg.pkg_type || 'Local'; // Usa "Local" como predeterminado si no se encuentra `pkg_type`

        tmpPackage.push({
          country: pkg.pkg_country,
          countryimg: packagesMap[pkg.pkg_country_code].image,
          voice: pkg.pkg_voice,
          amount: pkg.pkg_amount,
          data: pkg.pkg_data,
          manual_installation: pkg.pkg_manual_installation,
          net_price: pkg.pkg_price,
          type: type, // Asignar el `type` al paquete
          title: pkg.pkg_title,
          is_unlimited: pkg.pkg_is_unlimited,
          qr_installation: pkg.pkg_qr_installation,
          price: pkg.pkg_price,
          id: pkg.pkg_id,
          text: pkg.pkg_text,
          day: pkg.pkg_day,
          operador: [{
            operador: pkg.operador_title ?? '',
            type: pkg.operador_plan_type ?? '',
            prepaid: pkg.pkg_is_prepaid === 'true',
            esimtype: pkg.operador_apn_type ?? '',
            apn_type: pkg.operador_apn_type ?? '',
            apn_value: pkg.operador_apn_value ?? '',
            is_roaming: pkg.operador_is_roaming ?? '',
            info: pkg.operador_info ?? '', // 👈 SIEMPRE vacío si es null/undefined
            image: pkg.operador_url || 'https://cdn-dev.zendy.tel/images/Promo-Zendy-3-24@3x.png',
            plan_type: pkg.operador_plan_type ?? '',
            activation_policy: pkg.operador_activation_policy ?? '',
            is_kyc_verify: pkg.operador_is_kyc_verify ?? '',
            rechargeability: pkg.operador_rechargeability ?? '',
            other_info: pkg.operador_other_info ?? ''
          }]
        });
      }
    });

    sessionStorage.removeItem('back_url');
    sessionStorage.removeItem('package_id');

    return tmpPackage[0];
  }

  async ngOnInit() {
    this.package_id = this.route.snapshot.queryParamMap.get('package_id') || '';
    this.returnCountry = this.route.snapshot.queryParamMap.get('country');
    this.returnType = this.route.snapshot.queryParamMap.get('type');
    this.returnView = this.route.snapshot.queryParamMap.get('view');

    const back_package_id = sessionStorage.getItem('package_id');

    // Fast path: data already available from router state (navigating from packages list)
    if (history.state.data && !back_package_id) {
      this.applyEsimData(history.state.data);
      this.isLoadingDetails = false;
      // Load auth and promos in background without blocking the UI
      this.loadAuthAndPromos();
      return;
    }

    // Slow path: no router state data, fetch from API
    try {
      await this.auth.refresh();
      this.user = await Auth.currentAuthenticatedUser();
      const attributes = await Auth.userAttributes(this.user);

      const userSub = attributes.find(attribute => attribute.Name === 'sub')?.Value;
      const address = attributes.find(attribute => attribute.Name === 'custom:address')?.Value;
      const country = attributes.find(attribute => attribute.Name === 'custom:country')?.Value;
      const city = attributes.find(attribute => attribute.Name === 'custom:ciudad')?.Value;
      const zipcode = attributes.find(attribute => attribute.Name === 'custom:postcode')?.Value;
      const passport = attributes.find(attribute => attribute.Name === 'custom:passport')?.Value;

      this.sendToProfile = !(address !== "" && address !== undefined && city !== "" && city !== undefined && zipcode !== "" && zipcode !== undefined && passport !== "" && passport !== undefined && country !== "" && country !== undefined && userSub !== "");

      if (!this.sendToProfile) {
        sessionStorage.removeItem('onsignup_esim_data');
      }

      const [isPromo, esimData] = await Promise.all([
        this.promoService.isPromosActive("esim"),
        this.getPackage(back_package_id || this.package_id)
      ]);

      this.isPromoAvailable = isPromo;
      this.applyEsimData(esimData);
    } catch (error) {
      this.auth.logout();
    } finally {
      this.isLoadingDetails = false;
    }
  }

  openProfileModal() {
    sessionStorage.setItem('back_url', '/esim-details');
    sessionStorage.setItem('package_id', this.esimDetails.id);

    this.dialog
      .open(CompleteProfileModalComponent, {
        width: this.isMobile ? '85%' : '20%',
        minHeight: '250px',
        panelClass: 'zendy-modal',
      })
      .afterClosed()
      .subscribe();
  }

  calculatePercentage(total: number | undefined, remaining: number | undefined): number {
    if (!total || !remaining) {
      return 0;
    }
    return ((total - remaining) / total) * 100;
  }

  // Convertir MB a GB
  convertDataUnits(value: number | null | undefined): string {
    if (!value) {
      return '0 MB';
    }

    if (value >= 1024) {
      const gbValue = (value / 1024).toFixed(2);
      return `${gbValue} GB`;
    } else {
      return `${value} MB`;
    }
  }

  updatePrice(quantity: number = 0) {
    this.quantity = quantity != 0 ? quantity : this.quantity;
    let promodiscount = 0;
    this.priceBeforePromo = null;
    this.finalPrice = (parseFloat(this.esimDetails.price) * this.quantity);
    const promo = this.promo?.promos[0];
    if (promo) {
      const discountNum = this.quantity < promo.quantity || !promo.quantity || promo.quantity == 0 ? this.quantity : promo.quantity;
      promodiscount = promo.unit == "" ? promo.discount * discountNum : parseFloat(this.esimDetails.price) * discountNum * promo.discount / 100
      this.priceBeforePromo = this.finalPrice;
    }
    this.finalPrice -= promodiscount;

  }

  fetchInstallationGuide(iccid: string): void {
    this.isLoading = true;
    this.esimService.getInstallationGuide(iccid).then(response => {
      if (response && response.data && response.data.instructions) {
        this.installationGuide = {
          ios: response.data.instructions.ios[0],
          android: response.data.instructions.android[0]
        };
      }
      this.isLoading = false;
    }).catch(error => {
      console.error('Error fetching installation guide:', error);
      this.isLoading = false;
    });
  }

  selectPlatform(platform: 'android' | 'ios'): void {
    this.selectedPlatform = platform;
  }

  goBack(): void {
    sessionStorage.removeItem('onsignup_esim_data');

    // If we have return state, navigate back with query params
    if (this.returnView === 'packages' && this.returnCountry && this.returnType) {
      this.router.navigate(['/esim'], {
        queryParams: {
          country: this.returnCountry,
          type: this.returnType,
          view: 'packages'
        }
      });
    } else {
      // Fallback to simple navigation
      this.router.navigate(['/esim']);
    }
  }

  onRecharge(iccid: string): void {
    this.router.navigate(['/topup', iccid]);
  }

  async onBuyNow(): Promise<void> {
    this.showSpinner = true;
    this.isLoading = true;

    const { id: packageId } = this.esimDetails;
    const { country } = this.esimDetails;
    const operatorTitle = this.esimDetails.operador[0].operador;
    const tpvType = 'Esim';
    const quantity = this.quantity;
    const finalPrice = this.finalPrice;
    const promoCode = this.priceBeforePromo ? this.promoCode : null;

    if (!packageId) {
      console.error('No package_id');
      this.snackBar.open('No package_id found', 'Close', { duration: 3000 });
      return;
    }

    try {
      const orderData: any = {
        packageId,
        quantity,
        country,
        operatorTitle,
        finalPrice,
        promoCode
      };

      await this.esimService.submitOrder(orderData, tpvType, 0);
      this.globalDataService.invalidateUserEsims();
      this.snackBar.open('Order submitted successfully', 'Close', { duration: 3000 });
    } catch (error) {
      console.error('Order submission failed', error);
      this.snackBar.open('Order submission failed', 'Close', { duration: 3000 });
    } finally {
      this.showSpinner = false;
      this.isLoading = false;
    }
  }


  isQuantityValid(): boolean {
    const q = Number(this.quantity);
    return !isNaN(q) && q > 0 && q <= this.limit;
  }
}
export interface EsimDetails {
  country: string;
  data: string;
  type: string;
  title: string;
  is_unlimited: string;
  price: number | null;
  day: string;
  plan_type: string;
  prepaid: string;
  esimtype: string;
  apn_type: string;
  info: string;
  activation_policy: string;
  rechargeability: string;
  other_info: string;
}
